import { c as _c } from "react/compiler-runtime";
import { HotelListHeaderTitlePropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelCityTitle: FC<HotelListHeaderTitlePropertiesType> = t0 => {
  const $ = _c(10);
  const {
    city,
    totalItem,
    hasCityPrefix: t1,
    loading,
    isNewPlP: t2,
    className
  } = t0;
  const hasCityPrefix = t1 === undefined ? true : t1;
  const isNewPlP = t2 === undefined ? false : t2;
  const router = useRouter();
  const t3 = `text-on-surface-high-emphasis text-body-2 w-full truncate pt-5 lg:pt-0 lg:font-medium ${className}`;
  let t4;
  if ($[0] !== city || $[1] !== hasCityPrefix || $[2] !== isNewPlP || $[3] !== loading || $[4] !== router || $[5] !== totalItem) {
    t4 = process.env.NEXT_PUBLIC_APP_NAME === "tour" ? loading ? <h2 className="inline">در جستجوی تور‌های {city} ...</h2> : <><span>{numberConvert(totalItem, {
          locale: "fa"
        })}{" "}</span><h2 className="inline">تور {city}</h2></> : city ? hasCityPrefix ? <><span className={`${process.env.NEXT_PUBLIC_APP_NAME === "villa" && isNewPlP ? "text-subtitle-1 pl-1" : ""}`}>{totalItem ? numberConvert(totalItem, {
          locale: router.locale
        }) : ""}</span>{" "}<h2 className={`${process.env.NEXT_PUBLIC_APP_NAME === "villa" && isNewPlP ? "text-subtitle-1" : ""} inline`}>{process.env.NEXT_PUBLIC_APP_NAME === "villa" && isNewPlP ? `اقامتگاه و ویلا در ${city}` : `اقامتگاه در ${city}`}</h2></> : <><span>{numberConvert(totalItem, {
          locale: router.locale
        })} </span><h2 className="inline">اقامتگاه</h2></> : <div className="h-6"><Skeleton shape="rectangle" /></div>;
    $[0] = city;
    $[1] = hasCityPrefix;
    $[2] = isNewPlP;
    $[3] = loading;
    $[4] = router;
    $[5] = totalItem;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3} data-testid="header_title">{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};